import React, { useRef } from "react";

import { DragAnimation } from "../DragAnimation";
import * as S from "./styles";

export const Slide20: React.FC = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const compositionRef = useRef<HTMLImageElement>(null);

  return (
    <S.Container>
      <DragAnimation />
      <S.Wrapper ref={wrapperRef}>
        <S.Composition ref={compositionRef} />
      </S.Wrapper>
    </S.Container>
  );
};
